// components/Login.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SlButton from '@shoelace-style/shoelace/dist/react/button';
import SlInput from '@shoelace-style/shoelace/dist/react/input';
import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlOption from '@shoelace-style/shoelace/dist/react/option';
import SlSelect from '@shoelace-style/shoelace/dist/react/select';
import SlCard from '@shoelace-style/shoelace/dist/react/card';

import { expertise } from './Expertise';
import FAQ from "./FAQ";
import ForgotPassword from './ForgotPassword';
import Footer from './Footer';

//Moving this to shell. Better in shell have a profile for renters and hide things like units,
//keep calendar, notifications
//import CreateNewFix from "./CreateNewFix";
import axios from 'axios';
import {URL} from "./App"

const typeMapping = {
  "1": "Tenant",
  "2": "Property-Manager",
  "3": "Vendor"
}

const typeMapping2 = {
  "Tenant": "1",
  "Property-Manager": "2",
  "Vendor": "3"
}





const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color:  "lavenderblush",
      margin: '0 auto',
      //backgroundColor: "#aea49e",
      //backgroundImage: "url(images/background2.png)",
      //backgroundSize: "contain"
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      fontWeight: "300",
      display: "flex",
      flexDirection: "column",
      justifySelf: "center"
    },
    title: {
      fontSize: '36px',
      marginBottom: '10px',
      fontWeight: "300"
    },
    subtitle: {
      fontSize: '23px',
      color: '#666',
    },
    benefitsSection: {
      marginBottom: '40px',
    },
    iagentSection: {
      marginBottom: "168px",
      marginTop: "99px"
    },
    sectionTitle: {
      fontSize: '28px',
      marginBottom: '20px',
      textAlign: 'center',
      fontWeight: "300"
    },
    benefitsGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '20px',
    },
    benefit: {
      flex: '1 1 200px',
      backgroundColor: 'transparent',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      textAlign: 'center',
      backdropFilter: "blur(7px)",
      border: "2px solid rgb(250, 250, 250, 0.2)",
      WebkitBackdropFilter: "blur(7px)"
    },
    keyValuesSection: {
      marginBottom: '40px',
    },
    valuesList: {
      listStyleType: 'none',
      padding: 0,
      fontSize: '18px',
    },
    footer: {
      textAlign: 'center',
      marginTop: '40px',
    },
  };


const css = `
  .app {
    text-align: center;
    min-height: 100vh;
    background-image: url('/images/Images/backgroundcleandark.png');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
    background-clip: border-box;
    padding: 2%;
  }
  .form-content {
    text-align: left;
    padding: '0 1rem';
}

  .app-header {
    text-align: right;
    border-bottom: 1px solid lightgray;
    gap: 17px;
    display: flex;
    flex-direction: column;
    justify-content: end;
  }

  .app-header-right {
    .sl-input {
      margin: 10px 0px;
    }

    .sl-button {
      margin: 10px 0px;
    }
  }

  .beforeAfterSection {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;

    img {
      width: 400px;
    }
  }

  @media screen and (min-width: 1100px) {
    .app-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 52px;
        padding: 10px;

        .app-header-right {
            text-align: right;
            gap: 17px;
            display: flex;
            flex-direction: row;
            justify-content: end;
            

            .sl-input {
              margin: 0px;
            }
            .sl-button {
              margin: 0px;
            }
        }

    }
    .beforeAfterSection {
      width: 100%;
      margin-bottom: 40px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      
      img {
        width: 700px;
      }
    }
  }
  sl-dialog {
    sl-input {
        margin: 35px 0px;
    }
    sl-radio-group {
      sl-radio {
        margin: 5px 0px;

        sl-icon {
          margin: 0px 5px;
        }
      }
    }
  }
  

  .app-header-left {
    text-align: right;
    gap: 17px;
    display: flex;
    flex-direction: row;
    justify-content: end;
  }

  .app-header-left > img {
    width: 125px;
  }

  .intro-video-container {
    display: flex;
    justify-content: center;
    margin: 20px 0 30px 0;
  }

  .intro-video {
    width: 100%;
    max-width: 900px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  }

  .video-responsive {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
    width: 100%;
    max-width: 900px;
  }

  .video-responsive iframe,
  .video-responsive video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  /* sl-input[data-invalid]::part(base) {
    border: 2px solid red;
  } */

  sl-input[data-valid]::part(base) {
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  #ai-agent {

    .chat-layout .chat-footer {
      border: none;
    }
    textarea {
        border-radius: 13px;
    }
  }

  /* ===========================
   GENERAL
=========================== */

.ai-features{
    padding:80px 0;
    font-family:Arial, Helvetica, sans-serif;
}

.ai-features .container{
    width: 100%;
    margin:auto;
}

.ai-features h2{
    font-size:54px;
    margin-bottom:25px;
    font-weight:700;
}

.ai-features .intro{
    font-size: 23px;
    margin-bottom: 55px;
}

/* ===========================
   FEATURE TABLE
=========================== */

.feature-list{

    border:1px solid #dcdfe7;
    border-radius:22px;
    overflow:hidden;

}

.feature-row{

    display:grid;
    grid-template-columns:489px 1fr;

    height: 472px;

    border-bottom:1px solid #dcdfe7;

}

.feature-row:last-child{

    border-bottom:none;

}

.feature-number{
    align-content: center;

    >img {
      width: 500px;
    }
}

.feature-content{
    text-align: left;
    padding:38px 42px;
        align-content: center;
}

.feature-content h3{
    font-size: 28px;
    margin-bottom: 18px;
    font-weight: 700;
}

.feature-content p{
    font-size: 20px;
}

/* ===========================
   RESPONSIVE
=========================== */

@media(max-width:900px){

.ai-features h2{
    font-size:36px;
}

.ai-features .intro{

    font-size:20px;

}

.feature-row{

    grid-template-columns:489px 1fr;
        height: 585px;

}

.feature-number{

    font-size:28px;

}

.feature-content{

    padding:24px;

}

.feature-content h3{

    font-size:24px;

}

.feature-content p{

    font-size:17px;

}

}

@media(max-width:640px){

.feature-row{

    grid-template-columns:1fr;

}

.feature-number{

    height:190px;

}
.feature-number{

    >img {
      width: 320px;
    }
}

}

/*=================================================
    AI COMPARISON SECTION
==================================================*/

.ai-comparison{

    padding:90px 0;


}

.ai-comparison .container{

    width:96%;

    max-width:1700px;

    margin:auto;

}

.ai-comparison h2{
    font-size:36px;
    margin-bottom:25px;
    font-weight:700;
}

.ai-comparison .intro{
    font-size: 23px;
    margin-bottom: 55px;
}

/*=================================================
    TABLE
==================================================*/

.comparison-table{

    border:1px solid #d7dce5;

    border-radius:22px;

    overflow:hidden;

}

.table-header{

    display:grid;

    grid-template-columns:
        1.1fr
        1.45fr
        1.55fr
        0.45fr;

    background-color: var(--sl-color-primary-600);

    font-weight:500;

    font-size: 25px;

}

.table-header div{

    padding:28px;

}

.table-row{

    display:grid;

    grid-template-columns:
        1.1fr
        1.45fr
        1.55fr
        0.45fr;

    border-bottom:1px solid #dde1ea;

}

.table-row:nth-child(even){



}

.table-row:last-child{
    border-bottom:none;
}

.table-row>div{
    padding: 28px;
    font-size: 22px;
    text-align: left;
    line-height: 1.5;
}

.label{
    font-weight:600;
}

.improvement{
    color:#1c2d84 !important;
    font-weight:700;
}

/*=================================================
    RESPONSIVE
==================================================*/

@media (max-width:1100px){

.table-header{

    display:none;

}

.table-row{

    display:block;

    padding:20px;

}

.table-row>div{

    padding:12px 0;

    font-size:18px;

}

.table-row>div:before{

    display:block;


    font-weight:500;

    margin-bottom:6px;

}

.table-row>div:nth-child(1):before{

    content:"Performance";

}

.table-row>div:nth-child(2):before{

    content:"Traditional";

}

.table-row>div:nth-child(3):before{

    content:"AI-Driven";

}

.table-row>div:nth-child(4):before{

    content:"Improvement";

}

.ai-comparison h2{

    font-size:36px;

}

.ai-comparison .intro{

    font-size:20px;

}




}

.card-holder {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;

    sl-card::part(base) {
          height: 148px;
    }

     sl-card::part(base):hover {
          border-width: 3px;
    }

    sl-icon {
        font-size: 49px;
        margin-bottom: 15px;
    }

  .card-image {
    width: 180px;
    padding: 20px;
    margin: 1vw;
  }

  .card-image:hover {
    cursor: pointer;
  }

  .create-user-footing-terms {
    text-align: start;
    font-size: small;
  }
}

.15-day-trial::part(base) {
  font-size: 16px;
}


`
const getSignupDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return year + "-" + month + "-" + day;
};

function Login(props) {
    //Overlay
  const [open, setOpen] = useState(false);
  const emailInputRef = useRef(null);
  const [credentials, setCredentials] = useState({ 
    username: "", 
    password: "", 
    propertymanager: "Tenant", 
    language: [],
    property: "", 
    unit: "" ,
    phone: "",
    company: "",
    address: "",
    policynumber: "",
    policyprovider: "",
    expertise: [],
    pmemail: "",
    plan: "free",
    signupdate: "",
  });
  const [isTenant, setIsTenant] = useState(true);
  const [isVendor, setIsVendor] = useState(false);
  const [dataUnits, setDataUnits] = useState([]);
  const [dataProperty, setDataProperty] = useState([]);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [cardsUser, setCardsUser] = useState(true)

  const fetchUnits = async () => {
    try {
        const response = await axios.get(`${URL}/api/units`); // Adjust port if needed
        setDataUnits(response.data);
    } catch (error) {
        console.error('Error fetching items:', error);
    }
  }

  const fetchProperty = async () => {
      try {
          const response = await axios.get(`${URL}/api/property`); // Adjust port if needed
          setDataProperty(response.data);
      } catch (error) {
          console.error('Error fetching items:', error);
      }
    }

  useEffect(() => { 
    fetchUnits();
    fetchProperty();
    //const isAuthenticated = localStorage.getItem('authToken'); // Check for token
  
    

  }, []);

  useEffect(() => {
      if ( 
        credentials.propertymanager === "Tenant"
      ) {
        setIsTenant(true);
      } else if (
        credentials.propertymanager === "Vendor"
      ) {
        setIsTenant(false);
        setIsVendor(true)
      } else {
        setIsTenant(false);
        setIsVendor(false)
      }
    }, [credentials.propertymanager]
  )



  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLoginSubmit = async (e) => {    
    e.preventDefault();
    // Simulate API call
    //btoa(username + ':' + password)
    const token =  btoa(`${credentials.username}:${credentials.password}`);
    try {
      await axios.post(`${URL}/api/login`, {}, {
        headers: {
          'Authorization': `Basic ${token}` 
        }
      }).then(response=>{
        if (response.data.message === "Authentication successful") {
          const userDetails = {
            firstname: response.data.firstname,
            lastname: response.data.lastname,
            username: response.data.username,
            propertymanager: response.data.propertymanager,
            language: response.data.language,
            pmemail: response.data.pmemail,
            plan: response.data.plan || "free",
            signupdate: response.data.signupdate || "",
            phone: response.data.phone,
            expertise: response.data.expertise,
            property: response.data.property,
            unit: response.data.unit
          }
          console.log(userDetails)
          const userString = JSON.stringify(userDetails);
          localStorage.setItem('authToken', userString); // Store token
          navigate('/propertymanagement');
        }
      });
      
    } catch (error) {
      console.error('Error creating user', error);
      if (error.response.data.error === "Authentication failed. User not found.") {
        alert(error.response.data.error)
      } else if (error.response.data.error === "Authentication failed. Incorrect password.") {
        alert(error.response.data.error)
      }
    }


  };

  const createUser = async () => {
    if (emailInputRef.current && !emailInputRef.current.reportValidity()) {
      return;
    }

    try {
      await axios.post(`${URL}/api/register`, { ...credentials, signupdate: getSignupDate() }).then(response=>{

        if (response.data && response.data.message === "Username already exists.") {
          alert("Username already exists.")
        }


        setCredentials({ 
          firstname: "",
          lastname: "",
          username: "", 
          password: "",
          propertymanager: "Tenant",
          language: ["english"],
          phone: "",
          unit: "",
          property: "",
          company: "",
          address: "",
          policynumber: "",
          policyprovider: "",
          expertise: [],
          pmemail: "",
          plan: "free",
          signupdate: "",
        })

        setOpen(false);

        handleLoginSubmit({preventDefault: ()=>{}});
        
      });
      


      
    } catch (error) {
      if (error.response.data.error === "Username already exists.") {
        alert("Username already exists.")
      } else {
        alert(error.response.data.error)
      }
    }
  }
  const closeDialog = (e) => {

    if (e.target.localName === "sl-select") {
      return
    }
    setCredentials({ 
        firstname: "",
        lastname: "",
        username: "", 
        password: "",
        propertymanager: "Tenant",
        language: ["english"],
        phone: "",
        unit: "",
        property: "",
        company: "",
        address: "",
        policynumber: "",
        policyprovider: "",
        expertise: [],
        pmemail: "",
        plan: "free",
        signupdate: "",
    })
    setOpen(false);
    setCardsUser(true);
  }



const _onClick = (value)=>{
  console.log(value)
  setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: value,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })
          setCardsUser(false)
          }

/*   onSlAfterShow={()=>setCredentials({ 
          firstname: "",
          lastname: "",
          username: "", 
          password: "",
          propertymanager: "Tenant",
          unit: "",
          property: ""
      })} */

          const userComplete = credentials.firstname &&
        credentials.lastname &&
        credentials.username &&
        credentials.password &&
        credentials.propertymanager &&
        credentials.phone 
        ? false : true;

  return (
    <div className="app">
      

      <SlDialog 
        label="Sign Up" 
        open={open} 
        onSlAfterHide={closeDialog}
        
    >
      {cardsUser && <div className="card-holder">
         <SlCard className="card-image" id={"Homeowner"} onClick={()=>_onClick("Homeowner")}>
                  <SlIcon name="person"></SlIcon>
                  <div className="card-title">Homeowner (Single Unit)</div>
                </SlCard>
                <SlCard className="card-image" id={"Property-Manager"} onClick={()=>_onClick("Property-Manager")}>
                  <SlIcon name="houses"></SlIcon>
                  <div className="card-title">Property Manager</div>
                </SlCard>
                
                <SlCard className="card-image" id={"Tenant"} onClick={()=>_onClick("Tenant")}>
                  <SlIcon name="person-heart"></SlIcon>
                  <div className="card-title">Tenant</div>
                </SlCard>
                
                <SlCard className="card-image" id={"Vendor"} onClick={()=>_onClick("Vendor")}>
                 <SlIcon name="tools"></SlIcon>
                  <div className="card-title"> Vendor</div>
                </SlCard>
               <div className="create-user-footing-terms">
                By creating an account, you agree to HomeKeepy's <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.
               </div>
      </div>
      
      
      }

      {!cardsUser && <div className="form-content">
        <SlInput 
            placeholder="First Name"
            required={true}
            onSlInput={(e)=>setCredentials({
                firstname: e.target.value,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",

            })}
        />
        <SlInput 
            placeholder="Last Name"
            required={true}
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: e.target.value,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
          <SlInput 
            ref={emailInputRef}
            placeholder="Email"
            type="email"
            required={true}
            onSlInput={(e) => {
              const email = e.target.value.trim();
              const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
              e.target.setCustomValidity(
                email && !isValidEmail ? 'Please enter a valid email address.' : ''
              );
            }}
            onSlBlur={(e) => e.target.reportValidity()}
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: e.target.value,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
        <SlInput 
            type="password"
            required={true}
            placeholder="Create Password"
            help-text="Minimum 8 characters"
            password-toggle
            onSlInput={(e)=>setCredentials({
              firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: e.target.value,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />

      {/*   <SlRadioGroup 
                label="Select your role"  
                name="a" 
                value={typeMapping2[credentials.propertymanager]}
                onSlInput={(e)=>{
                    setCredentials({
                      firstname: credentials.firstname,
                      lastname: credentials.lastname,
                      username: credentials.username,
                      password: credentials.password,
                      propertymanager: typeMapping[e.target.value],
                      language: credentials.language,
                      phone: credentials.phone,
                      unit: credentials.unit,
                      property: credentials.property,
                      company: credentials.company,
                      address: credentials.address,
                      policynumber: credentials.policynumber,
                      policyprovider: credentials.policyprovider,
                      expertise: credentials.policyprovider,
                      pmemail: credentials.username,
                      plan: credentials.plan || "free",
                      signupdate: credentials.signupdate || "",
                    })
                    
                    //evaluatePropertyFields(props);
                  }}
                >

                <SlRadio value="2"><SlIcon name="person"></SlIcon>Property Manager/Owner</SlRadio>
                <SlRadio value="1"><SlIcon name="person-heart"></SlIcon>Tenant</SlRadio>
                <SlRadio value="3"><SlIcon name="tools"></SlIcon>Vendor</SlRadio>
              </SlRadioGroup> */}

              <SlInput 
            placeholder="Phone Number"
            label="Phone" 
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: e.target.value,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.username,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",

            })}
        />

         {isVendor && <SlSelect 
         placeholder="Select Languages. Multiple select if bilingual"
                                multiple={true}
                                 label="Languages" 
                                value={credentials.language}
                                onSlInput={
                                  (e)=>{setCredentials({
                                        firstname: credentials.firstname,
                                        lastname: credentials.lastname,
                                        username: credentials.username,
                                        password: credentials.password,
                                        propertymanager: credentials.propertymanager,
                                        language: e.target.value,
                                        phone: credentials.phone,
                                        unit: credentials.unit,
                                        property: credentials.property,
                                        company: credentials.company,
                                        address: credentials.address,
                                        policynumber: credentials.policynumber,
                                        policyprovider: credentials.policyprovider,
                                        expertise: credentials.policyprovider,
                                        pmemail: credentials.username,
                                        plan: credentials.plan || "free",
                                        signupdate: credentials.signupdate || "",
                                    })}}>
                            
                                <SlOption value={"English"}>🇺🇸English</SlOption>
                                <SlOption value={"espanol"}>🇪🇸Español</SlOption>
                              </SlSelect> }


              {/*isTenant && 
              <>
              
              <SlSelect 
                  placeholder="Select Property" 
                   label="Property" 
                  value={credentials.property}
                  onSlInput={
                    (e)=>{setCredentials({
                          firstname: credentials.firstname,
                          lastname: credentials.lastname,
                          username: credentials.username,
                          password: credentials.password,
                          propertymanager: credentials.propertymanager,
                          phone: credentials.phone,
                          unit: credentials.unit,
                          property: e.target.value,
                          company: credentials.company,
                          address: credentials.address,
                          policynumber: credentials.policynumber,
                          policyprovider: credentials.policyprovider,
                          expertise: credentials.policyprovider,
                          pmemail: credentials.pmemail,
                          plan: credentials.plan || "free",
                          signupdate: credentials.signupdate || "",
                      })}}>
              
                  {dataProperty && dataProperty.map((ele, index)=><SlOption key={index} value={ele.name.replaceAll(" ", "_").trim()}>{ele.name}</SlOption>)}
                </SlSelect>

                <SlSelect 
                    placeholder="Select Unit" 
                     label="Unit" 
                    value={credentials.unit}
                    onSlInput={
                      (e)=>{setCredentials({
                            firstname: credentials.firstname,
                            lastname: credentials.lastname,
                            username: credentials.username,
                            password: credentials.password,
                            propertymanager: credentials.propertymanager,
                            phone: credentials.phone,
                            unit: e.target.value,
                            property: credentials.property,
                            company: credentials.company,
                            address: credentials.address,
                            policynumber: credentials.policynumber,
                            policyprovider: credentials.policyprovider,
                            expertise: credentials.policyprovider,
                            pmemail: credentials.pmemail,
                            plan: credentials.plan || "free",
                            signupdate: credentials.signupdate || "",
                        })}}>
                
                    {dataUnits && dataUnits.map((ele, index)=><SlOption key={index} value={ele.name.replaceAll(" ", "_").trim()}>{ele.name}</SlOption>)}
                  </SlSelect>
              </>
              
              */}

              {(isVendor || isTenant) && 
              
              <SlInput 
            placeholder="Property Manager Email"
            label="Property Manager Email" 
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: e.target.value,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
              }

              {isVendor && 
              <>
              
              <SlInput 
            placeholder="Company Name"
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: e.target.value,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.pmemail,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",

            })}
        />
        <SlInput 
            placeholder="Address"
            required={true}
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: e.target.value,
                policynumber: credentials.policynumber,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.pmemail,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
        <SlInput 
            placeholder="Policy Number"
            required={true}
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: e.target.value,
                policyprovider: credentials.policyprovider,
                expertise: credentials.policyprovider,
                pmemail: credentials.pmemail,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
        <SlInput 
            placeholder="Policy Provider"
            required={true}
            onSlInput={(e)=>setCredentials({
                firstname: credentials.firstname,
                lastname: credentials.lastname,
                username: credentials.username,
                password: credentials.password,
                propertymanager: credentials.propertymanager,
                language: credentials.language,
                phone: credentials.phone,
                unit: credentials.unit,
                property: credentials.property,
                company: credentials.company,
                address: credentials.address,
                policynumber: credentials.policynumber,
                policyprovider: e.target.value,
                expertise: credentials.policyprovider,
                pmemail: credentials.pmemail,
                plan: credentials.plan || "free",
                signupdate: credentials.signupdate || "",
            })}
        />
              <SlSelect 
                  placeholder="Select Expertise" 
                  label="Expertise" 
                  multiple={true}
                  value={credentials.expertise}
                  onSlInput={
                    (e)=>{
                      setCredentials({
                          firstname: credentials.firstname,
                          lastname: credentials.lastname,
                          username: credentials.username,
                          password: credentials.password,
                          propertymanager: credentials.propertymanager,
                          language: credentials.language,
                          phone: credentials.phone,
                          unit: credentials.unit,
                          property: credentials.property,
                          company: credentials.company,
                          address: credentials.address,
                          policynumber: credentials.policynumber,
                          policyprovider: credentials.policyprovider,
                          expertise: e.target.value,
                          pmemail: credentials.pmemail,
                          plan: credentials.plan || "free",
                          signupdate: credentials.signupdate || "",
                      })}}>
              
                  {expertise && expertise.map((ele, index)=><SlOption key={index} value={ele.name.replaceAll(" ", "_").trim()}>{ele.name}</SlOption>)}
                </SlSelect>
              </>
              
              }

        </div>}
        

        <SlButton slot="footer" variant="default" onClick={closeDialog}>
          Cancel
        </SlButton>
        <SlButton slot="footer" variant="primary" onClick={createUser} disabled={userComplete}>
          Submit
        </SlButton>
      </SlDialog>
        
      {showForgotPassword ? (
        <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '500px', width: '100%' }}>
            <ForgotPassword onBack={() => setShowForgotPassword(false)} />
          </div>
        </div>
      ) : (
      <>
        <header className="app-header">
          <div className="app-header-left">
            
            <img
            slot="image"
            src="./images/LogoSerale.png"
            alt="logo"
          />
           <SlButton variant="primary" onClick={() => navigate('/propertydevelopment')}>
              Development Portal
            </SlButton>
          </div> 
          <div className="app-header-right">
            <SlInput 
              className={"sl-input"}  
              value={credentials.username}
              name="username"
              type="email"
              required={true}
              placeholder="Username"
              onSlInput={(e)=>handleChange(e)}
            />
            <SlInput 
              type="password"
              name="password"
              required={true}  
              className={"sl-input"}
              value={credentials.password}
              minlength="8"
              placeholder="Password"
              password-toggle
              onSlInput={(e)=>handleChange(e)}
            />
            <SlButton className={"sl-button"} variant="primary" onClick={handleLoginSubmit}>
              Login
            </SlButton>
            <SlButton className={"sl-button"} variant="text" onClick={() => setShowForgotPassword(true)}>
              Forgot Password ?
            </SlButton>
            <SlButton className={"sl-button"} variant="default" onClick={() => setOpen(true)}>
              Signup (Free)
            </SlButton>
            
          </div>
        </header>
        <div style={styles.container} className="container" id="container">
          <header style={styles.header}>
            <img
            style={{width: "217px", marginTop: "30px", alignSelf: "center"}}
                  slot="image"
                  src="./images/LogoSerale.png"
                  alt="JADU."
            />

             <SlButton className="15-day-trial" style={{marginTop: "33px", width: "200px", alignSelf: "center"}} variant="default" onClick={() => setOpen(true)}>
             <b>Start 30 day trial</b>
            </SlButton>
            <h1 style={styles.title}>AI Property Maintenance Operation Management</h1>

            <h2 style={{fontWeight: "300"}}>Smarter Property Management Starts with AI</h2>
           {/*  <p style={styles.subtitle}>Homekeepy is the all-in-one intelligent platform that helps property managers stay ahead with predictive maintenance, automated work orders, vendor search and communication, and real-time visibility into asset repair and maintenance health across every property.</p> */}
          </header>

        {/*    <section>
                  <ChatBot source="login" user={{propertymanager: "general"}}/>
          
              </section>  */}
          
          <section style={styles.benefitsSection}>
            <h2 style={styles.sectionTitle}>Main Features</h2>
            <div style={styles.benefitsGrid}>

               <div style={styles.benefit}>
                <h3>Maintenance Scheduling</h3>
                <p>Add Inspection Report and Appliances Info. Condition-based dynamic scheduling AI generated.</p>
              </div>
              
              <div style={styles.benefit}>
                <h3>Work Order Management</h3>
                <p>Vendor Management, Schedule Repairs and Maintenance, Invoicing and Payments.</p>
              </div>
              {/*  <div style={styles.benefit}>
                <h3>Tenant Placement</h3>
                <p>Home Marketing and Open House, Leasing/Background Check, Tenant Onboarding.</p>
              </div> */}
              <div style={styles.benefit}>
                <h3>Vendor Productivity & Management</h3>
                <p>Manage vendors, assign work orders, and follow up on proposals/quotes.</p>
              </div>

               <div style={styles.benefit}>
                <h3>Tenant Management</h3>
                <p>Are you a Property Manager? Tenant Management and 24/7 Repair and Emergency Notifications</p>
              </div>

              
             
             {/*  <div style={styles.benefit}>
                <h3>Vendor Management</h3>
                <p>Quotes and work proposals analysis.</p>
              </div> */}
            </div>
          </section> 

          <section className="ai-features">

    <div className="container">

        <h1 style={styles.title}>What AI Actually Does in Property Maintenance</h1>

       {/*  <p className="intro">
            AI in property maintenance is not a single technology—it is a collection of
            intelligent capabilities applied throughout the maintenance lifecycle.
            Understanding where each capability creates value helps property teams
            prioritize investments and accelerate digital transformation.
        </p> */}

        <div className="feature-list">


            <div className="feature-row">
 <div className="feature-number">
                    <img src="./images/picturerepair.png" alt="chat ai" />
                </div>

                <div className="feature-content">
                    <h3>Work Order Management</h3>

                    <p>
                        Repair and maintenance requests are automatically triaged and assigned to the appropriate vendors or maintenance personnel
                         based on factors such as availability, expertise, and location. This ensures that issues are addressed promptly and 
                         efficiently.
                    </p>
                </div>

               

            </div>

            <div className="feature-row">

                <div className="feature-number">
                    <img  src="./images/picturecalendar.png" alt="chat ai" />
                </div>

                <div className="feature-content">
                    <h3>Maintenance Scheduling</h3>

                    <p>
                        Condition-based dynamic scheduling. Create a prompt or add an Inspection Report to automatically schedule maintenance based on the condition of the property,
                         rather than relying on fixed calendar intervals. This approach optimizes resource allocation and reduces unnecessary
                          maintenance costs.
                    </p>
                </div>

            </div>

            <div className="feature-row">
 <div className="feature-number">
                    <img src="./images/picturevendor.png" alt="chat ai" />
                </div>
                

                <div className="feature-content">
                    <h3>Vendor Productivity & Management</h3>

                    <p>
                      Homekeepy provides a Vendor Management Portal. Manage vendors, assign work orders, and follow up on proposals/quotes. AI can analyze vendor performance data, track response times,
                       and provide insights to improve vendor selection and management processes. This helps property managers maintain a reliable network of 
                       vendors and ensures timely completion of maintenance tasks.


                    </p>
                </div>
               

            </div>

            <div className="feature-row">
 <div className="feature-number">
                    <img src="./images/pictureintegration.png" alt="AppFolio and HomeKeepy integration" />
                </div>
                

                <div className="feature-content">
                    <h3>Extend AppFolio with HomeKeepy</h3>

                    <p>
                      HomeKeepy integrates directly with AppFolio through our API integration, bringing powerful maintenance and repair capabilities into your existing workflow.

Keep using the best of AppFolio—while extending it with HomeKeepy. Manage maintenance, repairs, vendors, and property needs with HomeKeepy, without giving up the AppFolio features you already rely on.

                    </p>
                </div>
               

            </div>

             <div className="feature-row">

                <div className="feature-number">
                    <img src="./images/picturechat.png" alt="chat ai" />
                </div>

                <div className="feature-content">
                    <h3>Tenant Management</h3>

                    <p>
                        For those who manage more than 1 unit. We transfer data for free from other platforms. 24/7 Service AI-powered chatbots and virtual assistants can provide tenants with instant responses to common inquiries,
                         such as maintenance requests, billing questions, and lease information. This improves tenant satisfaction and reduces 
                         the workload on property management staff.
                    </p>
                </div>

            </div>

           {/*   <div className="feature-row">

                <div className="feature-number">
                    04
                </div>

                <div className="feature-content">
                    <h3>Asset Management</h3>

                    <p>
                        AI identifies unusual energy consumption patterns that often signal
                        developing mechanical problems before failure occurs. Maintenance
                        and energy management teams receive actionable insights from the
                        same data stream.
                    </p>
                </div>

            </div>
 */}
         {/*    <div className="feature-row">

                <div className="feature-number">
                    05
                </div>

                <div className="feature-content">
                    <h3>Compliance & Audit Automation</h3>

                    <p>
                        AI automatically organizes inspection reports, certifications,
                        maintenance logs, and compliance documentation into searchable
                        digital records with real-time dashboards that reduce compliance
                        risk and simplify audits.
                    </p>
                </div>

            </div> */}

        </div>

    </div>

</section>

 <SlButton className="15-day-trial"  style={{marginTop: "33px", marginBottom: "33px", width: "200px", alignSelf: "center"}} variant="default" onClick={() => setOpen(true)}>
             <b>Start 30 day trial</b>
            </SlButton>
        </div>
        <Footer />

        <style>{css}</style>
      </>
    )}
    </div>
  );
}

export default Login;
